module.exports = __webpack_public_path__ + "img/CardFront.b88e6d3f.png";